import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import Loader from './loader';

const Fact = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [factTitle, setFactTitle] = useState('');
    const [factDetail, setFactDetail] = useState('');

    useEffect(async () => {
        const fact = await Axios.get('https://yagrawlserver.herokuapp.com/api/blockfact/fact');
        setFactTitle(fact.data.fact);
        setFactDetail(fact.data.detail);
        setIsLoading(false);
    }, [])

    const buildUI = () => {
        if(isLoading) {
            return (
                <Loader></Loader>
            )
        } else {
            return (
                <div className='fact-box'>
                    <p className='fact-title'>{factTitle}</p>
                    <p className='fact-detail'>{factDetail}</p>
                </div>
            )
        }
    }

    return (
        <div>
            {buildUI()}
        </div>
    )
}

export default Fact;